'use strict';

const focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A",
]);
function isElementKeyboardAccessible(element) {
    return (focusableElements.has(element.tagName) ||
        element.tabIndex !== -1);
}

exports.isElementKeyboardAccessible = isElementKeyboardAccessible;
//# sourceMappingURL=is-keyboard-accessible.cjs.map
